import { ReviewPromptPlatform } from '@shared/core/billing'
import { GetProfileResponseDto } from '@shared/core/users'
import { ALERT_CAMPAIGN_IDS } from './alerts.constants'
import { AlertCampaign, AlertCampaignId } from './alerts.types'

const PROFILE_DEPENDENT_CAMPAIGN_IDS: AlertCampaignId[] = [
  ALERT_CAMPAIGN_IDS.G2_CAPTERRA_REVIEW,
  ALERT_CAMPAIGN_IDS.KALAMA_TEASER,
  ALERT_CAMPAIGN_IDS.KALAMA_RENAMED,
  ALERT_CAMPAIGN_IDS.PAUSED_REMINDERS,
  ALERT_CAMPAIGN_IDS.SUBSCRIPTION_ENDED_REMINDERS,
  ALERT_CAMPAIGN_IDS.SHOPIFY_WORDPRESS_SURVEY,
  ALERT_CAMPAIGN_IDS.TYPEFORM_REVIEW,
]

export function shouldRecordCoordinatorSeenEvent(campaignId: AlertCampaignId): boolean {
  return campaignId !== ALERT_CAMPAIGN_IDS.G2_CAPTERRA_REVIEW
}

export function canRenderAlertCampaign(
  campaignId: AlertCampaignId,
  profile: GetProfileResponseDto | null,
  reviewPlatform: ReviewPromptPlatform | null,
): boolean {
  if (PROFILE_DEPENDENT_CAMPAIGN_IDS.includes(campaignId) && profile === null) {
    return false
  }

  return campaignId !== ALERT_CAMPAIGN_IDS.G2_CAPTERRA_REVIEW || reviewPlatform !== null
}

export function shouldClearSelectedCampaign(
  campaignId: AlertCampaignId | null,
  profile: GetProfileResponseDto | null,
  reviewPlatform: ReviewPromptPlatform | null,
): boolean {
  return campaignId !== null && !canRenderAlertCampaign(campaignId, profile, reviewPlatform)
}

export function getCoordinatorSeenEventCampaigns(campaigns: AlertCampaign[]): AlertCampaign[] {
  return campaigns.filter((campaign) => shouldRecordCoordinatorSeenEvent(campaign.id))
}
